import { useCallback, useEffect } from 'react';

import { MODAL_ID } from '../../../constants';
import { KEY } from '../../../enums';

export const useModalEscape = (identifier: string, callback: (modal: string) => void) => {
  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === KEY.ESCAPE) {
        const modals = document.querySelectorAll(`#${MODAL_ID}`);
        const nodes = Array.prototype.slice.call(modals, 0);
        const reverse = nodes.reverse();

        const [modal] = reverse;
        if (modal) {
          const visible = modal.getAttribute('data-visibile');
          const name = modal.getAttribute('data-identifier');
          if (identifier === name && visible === 'true') {
            callback(identifier);
          }
        }
      }
    },
    [identifier, callback]
  );
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
